import React from 'react'
import { Link } from 'react-router-dom'

import Logo from './logo'
import './footer.css'

const Footer = (props) => {
  return (
    <footer className="footer-thq-bh-footer-root-elm bh-footer-root">
      <div className="bh-footer-texture"></div>
      <div className="bh-footer-inner">
        <div className="bh-footer-statement-row">
          <h2 className="bh-footer-statement">
            Ready to inflate the fun at your next event?
          </h2>
          <div className="bh-footer-action-wrap">
            <a href="tel:954-471-5525" data-planned-page="Request a Booking">
              <div className="footer-thq-bh-footer-btn-dummy-elm bh-footer-btn-dummy">
                <span>954-471-5525</span>
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="m12 16l4-4l-4-4m-4 4h8"></path>
                </svg>
              </div>
            </a>
          </div>
        </div>
        <div className="bh-footer-body">
          <div className="bh-footer-nav-group">
            <nav className="bh-footer-nav">
              <Link to="/" className="footer-navlink1">
                <div className="bh-footer-nav-link">
                  <span>Home</span>
                </div>
              </Link>
              <span
                data-planned-page="Party Rentals"
                className="bh-footer-link-dummy"
              >
                Party Rentals
              </span>
              <span
                data-planned-page="Furniture &amp; Decor"
                className="bh-footer-link-dummy"
              >
                Seating &amp; Tables
              </span>
              <span className="bh-footer-link-dummy">Shelters</span>
              <span className="bh-footer-link-dummy">Decor</span>
              <span
                data-planned-page="Concession Rentals"
                className="bh-footer-link-dummy"
              >
                Concessions
              </span>
              <span
                data-planned-page="Marquee Numbers &amp; Letters"
                className="bh-footer-link-dummy"
              >
                Marquee Letters
              </span>
            </nav>
          </div>
          <div className="bh-footer-nav-group">
            <nav className="bh-footer-nav">
              <span
                data-planned-page="Packages &amp; Add‑Ons"
                className="bh-footer-link-dummy"
              >
                Bundles &amp; Packages
              </span>
              <span className="bh-footer-link-dummy">
                Ponies &amp; Petting Zoo
              </span>
              <span className="bh-footer-link-dummy">Trackless Train</span>
              <span className="bh-footer-link-dummy">
                In-Costume Entertainers
              </span>
              <span className="bh-footer-link-dummy">Face Painting</span>
              <span className="bh-footer-link-dummy">Balloon Artists</span>
            </nav>
          </div>
          <div className="bh-footer-meta">
            <Link to="/" className="footer-navlink2">
              <div className="bh-footer-logo-link">
                <Logo isOnDarkBackground></Logo>
              </div>
            </Link>
            <div className="bh-footer-contact">
              <p className="bh-footer-contact-label">Let&apos;s Chat</p>
              <a href="tel:954-471-5525">
                <div className="footer-thq-bh-footer-contact-value-elm bh-footer-contact-value">
                  <span>954-471-5525</span>
                </div>
              </a>
            </div>
            <div className="footer-thq-bh-footer-social-elm bh-footer-social"></div>
          </div>
        </div>
        <div className="bh-footer-legal">
          <div className="bh-footer-legal-copy">
            <span>© 2026 BounceHouseKatie.com. All rights reserved.</span>
            <Link to="/terms-conditions" className="footer-navlink3">
              <div className="bh-footer-legal-link">
                <span>Terms &amp; Privacy</span>
              </div>
            </Link>
          </div>
          <div className="bh-footer-tagline">
            <span>Making every bounce a memory.</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
